/*协议*/
import getTranslation from '@/locale/getTranslation'

export default {
  path: '/exhibitor',
  name: 'exhibitor',
  component: resolve => require(['@/views/exhibitorList/index'], resolve),
  children: [
    {
      path: '/',
      redirect: 'list'
    },
    {
      path: 'list',
      name: 'exhibitor-list',
      component: resolve => require(['@/views/exhibitorList/list'], resolve),
      meta: {
        title: getTranslation('展商名录'),
        keepAlive: true
      },
      beforeEnter: (to, from, next) => {
        window._isMobile ? next({ name: 'exhibitorListList' }) : next()
      }
    },
    {
      path: 'detail',
      name: 'exhibitor-detail',
      component: resolve => require(['@/views/exhibitorList/detail'], resolve),
      meta: {
        title: getTranslation('展商名录详情')
      },
      beforeEnter: (to, from, next) => {
        console.log('to', to)
        window._isMobile
          ? next({ name: 'exhibitorListDetail', query: to.query })
          : next()
      }
    },
    {
      path: 'search',
      name: 'search',
      component: resolve => require(['@/views/exhibitorList/search'], resolve),
      meta: {
        title: getTranslation('展商名录搜索')
      }
    },
    {
      path: '*',
      redirect: 'list'
    }
  ]
}
